<template>
    <li class="live-notification" v-show="latest">
        <span v-if="latest">
            <span class="pulse"></span><span class="title" v-show="title" v-html="title"></span>
        </span>
    </li>
</template>
<script>
export default {
    data: function () {
        return {
            latest: false,
            title: '',
            timeout: false
        };
    },
    created() {
        this.$eventHub.$on('latest-notif', this.update)
    },
    methods : {
        update(item) {
            this.latest = true;
            this.title = item.title;
            if(this.timeout) {
                clearTimeout(this.timeout);
            }
            if(typeof item.timeout !== 'undefined' && item.timeout) {
                this.timeout = setTimeout(this.clear, 8000);
            } else if(typeof item.hide !== 'undefined' && item.hide) {
                this.timeout = setTimeout(this.hideTitle, 8000);
            }
        },
        hideTitle(){
            this.title = '';
        },
        clear() {
            this.latest = false;
            this.title = '';
            this.timeout = false;
        }
    }
}
</script>
